import React, { useState, useEffect } from "react";
import { initGTM } from "./lib/gtm";
import { Route, Switch } from "react-router-dom";
import "./index.css";
import Layout from "./components/templates/Layout";

import MainPage from "./pages/MainPage";
import PlateNumber from "./pages/motor-insurance/plate-number";
import CarDetails from "./pages/motor-insurance/car-details";
import MotorcarQuotation from "./pages/motor-insurance/quotation";
import MotorcarOtherDetails from "./pages/motor-insurance/car-other-details";
import MotorcarSummary from "./pages/motor-insurance/summary.js";
import MotorcarReview from "./pages/motor-insurance/review.js";
import Wizard from "./pages/motor-insurance/step-wizard.js";
import LayoutNoFooter from "./components/templates/LayoutNoFooter";
import FormPage from "./pages/motor-insurance/form";
import LayoutPlain from "./components/templates/LayoutPlain";
import FaqPage from "./pages/FaqPage";
import FaqPageTravel from "./pages/FaqPageTravel";
import ContactUsPage from "./pages/ContactUsPage";
import Inclusions from "./pages/Inclusions";
import ExclusionPage from "./pages/Exclusions";
import PaymentSuccess from "./components/organisms/Payment-Success";
import ComingSoon from "./pages/ComingSoon";
import Maintenance from "./pages/Maintenance";
//ManagePolicy
import ManagePolicy from "./pages/ManagePolicy";
import CancelPage from "./components/organisms/ManagePolicy/CancelPolicy";
import PolicyList from "./components/organisms/ManagePolicy/PolicyList";
import PageNotFound from "./pages/404";
import PageError from "./pages/500";

import MainPageTravel from "./pages/MainPageTravel";
import { Loading } from "./components/atoms/loading.js";
// import InitialPage from "./pages/InitialPage";
//CTPL
// import CTPLForm from "./pages/ctpl/packages";
// import CTPLFormReview from "./pages/ctpl/review";
// import CTPLFormCarDetails from "./pages/ctpl/car-details";
// import CTPLFormOwnerDetails from "./pages/ctpl/owner-details";
// import CTPLFormSummary from "./pages/ctpl/summary";
import MainPageCTPL from "./pages/MainPageCTPL";
import FaqPageCTPL from "./pages/FaqPageCTPL";
//CTPL
import CTPLForm from "./pages/ctpl/packages";
import CTPLFormReview from "./pages/ctpl/review";
import CTPLFormCarDetails from "./pages/ctpl/form";
import CTPLCoverPage from "./pages/ctpl/covered";

//Travel
import TravelForm from "./pages/travel/form";
import TravelAssuredDetails from "./pages/travel/assured";
import TravelFormSummary from "./pages/travel/summary";
import TravelFormReview from "./pages/travel/review";
import TravelCovers from "./pages/travel/covered";
import CovidPage from "./pages/Covid";
import TravelBenefits from "./components/organisms/Travel-Insurance/Benefits";

//Pet
import PetIndex from "./pages/pet-insurance/index";
import PetInsurance from "./pages/pet-insurance/covered";
import PetReview from "./pages/pet-insurance/review";
import PetInsuranceFormsPage from "./pages/pet-insurance/pet-forms";
import PetFaq from "./pages/pet-insurance/pet-faq";
import CTPLCoverType from "./components/organisms/CTPL/cover-type";

//Renewal
import RenewalMotorIndex from "./pages/renewal/motor/index";


//Motorcycle
// import InfoFaqPage from "./pages/info/faq.js";
//import InfoFaqPage from "./pages/info/Faq.js";
// import InfoExclusionPage from "./pages/info/exclusion.js";
// import InfoInclusionPage from "./pages/info/Inclusions.js";

import {
  openlAPI,
  authAPI,
} from "./api/fetch-api.js";
import { Cache } from "aws-amplify";
import { getProductStatus, maintenanceMessage } from "./components/utils/helper.js";

// import MainPageMotorcycle from "./pages/MainPageMotorcycle.js";
// import FormMotorcyclePage from "./pages/motorcycle-insurance/form.js";
// import MotorcycleReview from "./pages/motorcycle-insurance/review.js";
import { useMemo } from "react";

const tagManagerArgs = {
  gtmId: "GTM-MGF68PX",
};
// const getProductStatus = (product) => {
//   console.log("PRODUCT", product);
//   const statusEntry = checker.find(
//     (item) => item.type === product && item.module === "ginsure"
//   );

//   console.log("statusEntry", statusEntry);

//   return statusEntry
//     ? {
//         isAvailable: statusEntry.status === "on",
//         message: statusEntry.message || null,
//       }
//     : { isAvailable: false, message: null };
// };

const sendGTM = (path, pageTitle, product, eventName) => {
  if (
    product != "" &&
    product != undefined &&
    eventName !== undefined &&
    eventName !== ""
  ) {
    // Ensure dataLayer exists: component effects can fire sendGTM before App's
    // initGTM effect runs (React runs child effects before parent effects).
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName, //"virtualPage", //eventTrigger
      pageUrl: window.location.hostname + path,
      product: product,
      pageTitle: pageTitle,
    });
  }
};



function App() {
  useEffect(() => {
    initGTM(tagManagerArgs.gtmId);
  }, []);

  const [authDone, setAuthDone] = useState(false);

  const [loading, setLoading] = useState(true);

  const [motorStatus, setMotorStatus] = useState({
    isAvailable: false,
    message: "",
  });
  const [motorcycleStatus, setMotorcycleStatus] = useState({
    isAvailable: false,
    message: "",
  });
  const [travelStatus, setTravelStatus] = useState({
    isAvailable: false,
    message: "",
  });
  const [ctplStatus, setCtplStatus] = useState({
    isAvailable: false,
    message: "",
  });
  const [petStatus, setPetStatus] = useState({
    isAvailable: false,
    message: "",
  });

  const [maintenanceStatus, setMaintenanceStatus] = useState({
    isAvailable: false,
    message: maintenanceMessage,
  });

  useEffect(() => {
    // authAPI.getAuth(authDetails).then((data1) => {
    //   Cache.setItem("ginsure_token", data1.token);
    //   setAuthDone(true);
    // });
  });
  const fetchedProducts = new Set();
  const fetchStatus = useMemo(() => async (productType) => {
      // Skip if already fetched for this product type
      if (fetchedProducts.has(productType)) {
        return;
      }
      fetchedProducts.add(productType);
    setLoading(true); // Set loading to true when fetching starts
    try {
      const status = await getProductStatus("GINSURE", productType);
      if(productType === "Motor"){
        setMotorStatus(status);
      }
      else if(  productType === "Motorcycle"){
        setMotorcycleStatus(status);
      } else if(productType === "Travel"){
        setTravelStatus(status);
      } else if(productType === "CTPL"){
        setCtplStatus(status);
      } else if(productType === "Pet"){
        setPetStatus(status);
      } 

    } catch (e) {
      const errorStatus = { isAvailable: false, message: "Error fetching data" };
      
      if(productType === "Motor"){
        setMotorStatus(errorStatus);
      } else if(productType === "Motorcycle"){
        setMotorcycleStatus(errorStatus);
      } else if(productType === "Travel"){
        setTravelStatus(errorStatus);
      } else if(productType === "CTPL"){
        setCtplStatus(errorStatus);
      } else if(productType === "Pet"){
        setPetStatus(errorStatus);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(()=>{
    const path = window.location.pathname;
    if (path.includes('/motorcycle')) {
      fetchStatus("Motorcycle");
    }
    else if (path.includes('/motor') || path === '/') {
      fetchStatus("Motor");
    }
    if (path.includes('/ctpl')) {
      fetchStatus("CTPL");
    }
    if (path.includes('/travel')) {
      fetchStatus("Travel");
    }
    if (path.includes('/pet')) {
      fetchStatus("Pet");
    }
  },[]);

  useEffect(() => {
  }, [motorStatus,motorcycleStatus,travelStatus, ctplStatus, petStatus]);

  return (
    <div>
      <Switch>
        <Route path="/" exact>
          <LayoutPlain
            main="main"
            buttonType="1"
            link="/motor-insurance/form"
            GATitle={"MotorCoverPage"}
            sendGTM={sendGTM}
          >
            {loading ? (
              <Loading />
            ) : motorStatus.isAvailable ? (
              <Maintenance
                headerTitle="Standard Insurance"
                message={motorStatus.message}
              />
            ) : (
              <MainPage headerTitle="GCash x Standard Insurance" />
            )}
          </LayoutPlain>
        </Route>

        {/* Pages Motor Insurance */}
        <Route path="/motor-insurance/plate-number" exact>
          <LayoutPlain
            headerTitle="Motorcar details"
            GATitle={"MotorFormsPlatenumber"}
            sendGTM={sendGTM}
          >
            <PlateNumber />
          </LayoutPlain>
        </Route>

        <Route path="/motor-insurance/car-details" exact>
          <Layout
            main="car-details"
            link="/motor-insurance/quotation"
            headerTitle="Motorcar details"
            GATitle={"MotorFormsCardetails"}
            sendGTM={sendGTM}
          >
            <CarDetails />
          </Layout>
        </Route>

        <Route path="/motor-insurance/quotation" exact>
          <Layout
            main="quotation"
            link="/motor-insurance/other-details"
            headerTitle="Premium Breakdown"
            GATitle={"MotorFormsQuotation"}
            sendGTM={sendGTM}
          >
            <MotorcarQuotation />
          </Layout>
        </Route>

        <Route path="/motor-insurance/other-details" exact>
          <Layout
            main="other-details"
            link="/motor-insurance/summary"
            headerTitle="Other Details"
            GATitle={"MotorFormsOtherDetails"}
            sendGTM={sendGTM}
          >
            <MotorcarOtherDetails />
          </Layout>
        </Route>

        <Route path="/motor-insurance/summary" exact>
          <Layout
            main="summary"
            headerTitle="Summary"
            GATitle={"MotorFormsSummary"}
            sendGTM={sendGTM}
          >
            <MotorcarSummary />
          </Layout>
        </Route>

        <Route path="/motor-insurance/step-wizard" exact>
          <Layout
            main="step-wizard"
            buttonType="1"
            GATitle={""}
            sendGTM={sendGTM}
          >
            <Wizard />
          </Layout>
        </Route>

        <Route path="/motor-insurance/review" exact>
          <LayoutPlain GATitle={"MotorFormsReview"} sendGTM={sendGTM}>
            <MotorcarReview />
          </LayoutPlain>
        </Route>

        <Route path="/motor-insurance/form" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <FormPage sendGTM={sendGTM} />
          </LayoutPlain>
        </Route>

        {/* Pages motorcycle Insurance */}
        {/* <Route path="/motorcycle" exact>
          <LayoutPlain
            main="main"
            buttonType="1"
            link="/motorcycle-insurance/form"
            GATitle={"MotorCoverPage"}
            sendGTM={sendGTM}
          >
            {loading ? (
              <Loading />
            ) : motorcycleStatus.isAvailable ? (
              <Maintenance
                headerTitle="Standard Insurance"
                message={motorcycleStatus.message}
              />
            ) : (
              <MainPageMotorcycle headerTitle="GCash x Standard Insurance" />
            )}
          </LayoutPlain>
        </Route>
        <Route path="/motorcycle-insurance/car-details" exact>
          <Layout
            main="car-details"
            link="/motorcycle-insurance/quotation"
            headerTitle="motorcyclecar details"
            GATitle={"motorcycleFormsCardetails"}
            sendGTM={sendGTM}
          >
            <CarDetails />
          </Layout>
        </Route>

        <Route path="/motorcycle-insurance/quotation" exact>
          <Layout
            main="quotation"
            link="/motorcycle-insurance/other-details"
            headerTitle="Premium Breakdown"
            GATitle={"motorcycleFormsQuotation"}
            sendGTM={sendGTM}
          >
            <motorcyclecarQuotation />
          </Layout>
        </Route>

        <Route path="/motorcycle-insurance/other-details" exact>
          <Layout
            main="other-details"
            link="/motorcycle-insurance/summary"
            headerTitle="Other Details"
            GATitle={"motorcycleFormsOtherDetails"}
            sendGTM={sendGTM}
          >
            <motorcyclecarOtherDetails />
          </Layout>
        </Route>

        <Route path="/motorcycle-insurance/summary" exact>
          <Layout
            main="summary"
            headerTitle="Summary"
            GATitle={"motorcycleFormsSummary"}
            sendGTM={sendGTM}
          >
            <motorcyclecarSummary />
          </Layout>
        </Route>

        <Route path="/motorcycle-insurance/step-wizard" exact>
          <Layout
            main="step-wizard"
            buttonType="1"
            GATitle={""}
            sendGTM={sendGTM}
          >
            <Wizard />
          </Layout>
        </Route>

        <Route path="/motorcycle-insurance/review" exact>
          <LayoutPlain GATitle={"motorcycleFormsReview"} sendGTM={sendGTM}>
            <MotorcycleReview />
          </LayoutPlain>
        </Route>

        <Route path="/motorcycle-insurance/form" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <FormMotorcyclePage sendGTM={sendGTM} />
          </LayoutPlain>
        </Route> */}

        {/* subpages */}

        <Route path="/faq" exact>
          <LayoutPlain GATitle={"FAQsPages"} sendGTM={sendGTM} main="summary">
            <FaqPage
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="FAQs"
            />
          </LayoutPlain>
        </Route>

        {/* asean/intl faq */}
        <Route path="/faq/:id" exact>
          <LayoutPlain
            GATitle={"TravelFAQsPages"}
            sendGTM={sendGTM}
            main="summary"
          >
            <FaqPageTravel
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="FAQs"
            />
          </LayoutPlain>
        </Route>

        <Route path="/contact" exact>
          <LayoutPlain GATitle={"ContactFormPage"} sendGTM={sendGTM}>
            <ContactUsPage
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="Contact Us"
            />
          </LayoutPlain>
        </Route>

        <Route path="/exclusions" exact>
          <LayoutPlain GATitle={"CoverExclusions"} sendGTM={sendGTM}>
            <ExclusionPage
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="Exclusions"
            />
          </LayoutPlain>
        </Route>

        <Route path="/inclusions" exact>
          <LayoutPlain GATitle={"CoverInclusions"} sendGTM={sendGTM}>
            <Inclusions
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="Inclusions"
            />
          </LayoutPlain>
        </Route>
        <Route path="/payment-success" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <PaymentSuccess
              headerTitle="Standard Insurance"
              sendGTM={sendGTM}
            />
          </LayoutPlain>
        </Route>

        <Route path="/coming-soon" exact>
          <ComingSoon headerTitle="Standard Insurance" />
        </Route>
        <Route path="/maintenance" exact>
          <Maintenance
            headerTitle="Standard Insurance"
            message={maintenanceStatus.message}
          />
        </Route>
        <Route path="/manage-policy/:id/cancel-request" exact>
          <CancelPage headerTitle="Cancel Policy" />
        </Route>
        <Route path="/manage-policy/:id">
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <ManagePolicy headerTitle="Policy Page" sendGTM={sendGTM} />
          </LayoutPlain>
        </Route>

        <Route path="/renewal/motor">
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <RenewalMotorIndex headerTitle="Renewal Motor" sendGTM={sendGTM} />
          </LayoutPlain>
        </Route>

        <Route path="/manage-policy/policy-list" exact>
          <PolicyList headerTitle="Policy Page" />
        </Route>
        <Route path="/500" exact>
          <PageError headerTitle="Standard Insurance" />
        </Route>

        <Route path="/404" exact>
          <PageNotFound headerTitle="404" />
        </Route>

        {/* <Route path="/ctpl" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM} main="main">
            <InitialPage headerTitle="GCash x Standard Insurance" />
          </LayoutPlain>
        </Route> 
        
        <Route path="/ctpl/packages" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM} main="main">
            <CTPLForm headerTitle="Standard Insurance" />
          </LayoutPlain>
        </Route>


        <Route path="/ctpl/car-details" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <CTPLFormCarDetails headerTitle="Motorcar Details" />
          </LayoutPlain>
        </Route>

        <Route path="/ctpl/owner-details" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <CTPLFormOwnerDetails headerTitle="Owner Details" />
          </LayoutPlain>
        </Route>

        <Route path="/ctpl/summary" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <CTPLFormSummary headerTitle="Summary" />
          </LayoutPlain>
        </Route>

        <Route path="/ctpl/review" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <CTPLFormReview headerTitle="Review" />
          </LayoutPlain>
        </Route> */}

        {/*  */}
        <Route path="/ctpl/" exact>
          <LayoutPlain
            GATitle={"CTPLMainCover"}
            sendGTM={sendGTM}
            main="main"
            buttonType="1"
          >
            {loading ? ( // Check loading state
              <Loading />
            ) : ctplStatus.isAvailable ? (
              <Maintenance
                headerTitle="Standard Insurance"
                message={ctplStatus.message}
              />
            ) : (
              // <Loading />
              <MainPageCTPL headerTitle="GCash x Standard Insurance" />
              // <Loading />
            )}
          </LayoutPlain>
        </Route>
        <Route path="/ctpl/type" exact>
          {/* <LayoutPlain GATitle={""} sendGTM={sendGTM} main="main">
            <InitialPage headerTitle="Gcash x Standard Insurance" />
          </LayoutPlain> */}
          <LayoutPlain
            GATitle={"CTPLCoverTypes"}
            sendGTM={sendGTM}
            main="main"
            buttonType="1"
          >
            <CTPLCoverType headerTitle="GCash x Standard Insurance" />
          </LayoutPlain>
        </Route>

        <Route path="/ctpl/type" exact>
          {/* <LayoutPlain GATitle={""} sendGTM={sendGTM} main="main">
            <InitialPage headerTitle="Gcash x Standard Insurance" />
          </LayoutPlain> */}
          <LayoutPlain
            GATitle={"CTPLCoverTypes"}
            sendGTM={sendGTM}
            main="main"
            buttonType="1"
          >
            <CTPLCoverType headerTitle="GCash x Standard Insurance" />
          </LayoutPlain>
        </Route>

        <Route path="/ctpl/faq" exact>
          <LayoutPlain GATitle={"CTPLFAQPage"} sendGTM={sendGTM} main="summary">
            <FaqPageCTPL
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="FAQs"
            />
          </LayoutPlain>
        </Route>

        <Route path="/ctpl/packages" exact>
          <LayoutPlain
            GATitle={"CTPLFormPackagesPage"}
            sendGTM={sendGTM}
            main="main"
          >
            <CTPLForm headerTitle="Standard Insurance" />
          </LayoutPlain>
        </Route>

        <Route path="/ctpl/form" exact>
          <LayoutPlain sendGTM={sendGTM}>
            <CTPLFormCarDetails
              headerTitle="Motorcar Details"
              sendGTM={sendGTM}
            />
          </LayoutPlain>
        </Route>
        <Route path="/ctpl/review" exact>
          <LayoutPlain GATitle={"CTPLFormsReview"} sendGTM={sendGTM}>
            <CTPLFormReview headerTitle="Review" />
          </LayoutPlain>
        </Route>

        <Route path="/ctpl/covered" exact>
          <LayoutPlain GATitle={"CTPLCoveredPage"} sendGTM={sendGTM}>
            <CTPLCoverPage headerTitle="Standard Insurance" />
          </LayoutPlain>
        </Route>
        {/*  */}

        <Route path="/travel/:id" exact>
          <LayoutPlain GATitle={"TravelMainCover"} sendGTM={sendGTM}>
            {/* <Maintenance headerTitle="Standard Insurance" /> */}
            {/* <TravelIndex headerTitle="GCash X Standard Insurance" />   */}
            {loading ? ( // Check loading state
              <Loading />
            ) : travelStatus.isAvailable ? (
              <Maintenance
                headerTitle="Standard Insurance"
                message={travelStatus.message}
              />
            ) : (
              <MainPageTravel headerTitle="GCash X Standard Insurance" />
            )}

            {/* {travelStatus.isAvailable && (
              <Maintenance
                headerTitle="Standard Insurance"
                message={travelStatus.message}
              />
            )} */}

            {/* {travelStatus.isAvailable && (
              <MainPageTravel headerTitle="GCash X Standard Insurance" />
            )} */}
          </LayoutPlain>
        </Route>

        <Route path="/travel/:id/cover" exact>
          <LayoutPlain GATitle={"TravelCoveredPages"} sendGTM={sendGTM}>
            <TravelCovers headerTitle="Standard Insurance" />
          </LayoutPlain>
        </Route>

        <Route path="/travel/:id/form" exact>
          <LayoutPlain>
            <TravelForm headerTitle="Standard Insurance" sendGTM={sendGTM} />
          </LayoutPlain>
        </Route>

        <Route path="/travel/assured" exact>
          <LayoutPlain GATitle={"TravelFormsAssuredDetails"} sendGTM={sendGTM}>
            <TravelAssuredDetails headerTitle="Standard Insurance" />
          </LayoutPlain>
        </Route>

        <Route path="/travel/summary" exact>
          <LayoutPlain GATitle={"TravelFormsSummary"} sendGTM={sendGTM}>
            <TravelFormSummary headerTitle="Standard Insurance" />
          </LayoutPlain>
        </Route>

        <Route path="/travel/:id/review" exact>
          <LayoutPlain GATitle={"TravelFormsReview"} sendGTM={sendGTM}>
            <TravelFormReview headerTitle="Standard Insurance" />
          </LayoutPlain>
        </Route>

        <Route path="/covid" exact>
          <LayoutPlain GATitle={"TravelCovidPage"} sendGTM={sendGTM}>
            <CovidPage
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="COVID-19 Coverage"
            />
          </LayoutPlain>
        </Route>

        <Route path="/travel/:id/benefits" exact>
          <LayoutPlain GATitle={"TravelBenefitsPage"} sendGTM={sendGTM}>
            <TravelBenefits
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="Travel Benefits"
            />
          </LayoutPlain>
        </Route>

        <Route path="/pet-insurance/" exact>
          <LayoutPlain
            GATitle={"PetMainCover"}
            sendGTM={sendGTM}
            main="main"
            buttonType="1"
            link="/pet-insurance/covered"
          >
            {loading ? ( // Check loading state
              <Loading />
            ) : petStatus.isAvailable ? (
              <Maintenance
                headerTitle="Standard Insurance"
                message={petStatus.message}
              />
            ) : (
              // <Loading />
              <PetIndex headerTitle="GCash x Standard Insurance" />
              // <Loading />
            )}
          </LayoutPlain>
        </Route>

        <Route path="/pet-insurance/covered" exact>
          <LayoutPlain GATitle={"PetCoveredPage"} sendGTM={sendGTM}>
            {/* <Maintenance headerTitle="Standard Insurance" /> */}
            <PetInsurance
              headerTitle="GCash x Standard Insurance"
              subheaderTitle=""
            />
          </LayoutPlain>
        </Route>
        <Route path="/pet-insurance/forms" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <PetInsuranceFormsPage
              headerTitle="GCash x Standard Insurance"
              subheaderTitle=""
              sendGTM={sendGTM}
            />
          </LayoutPlain>
        </Route>
        {/* <Route path="/pet-insurance/details" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <PetDetails
              headerTitle="GCash x Standard Insurance"
              subheaderTitle=""
            />
          </LayoutPlain>
        </Route>

        <Route path="/pet-insurance/quotation" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <PetQuotation
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="Quotation"
            />
          </LayoutPlain>
        </Route>

        <Route path="/pet-insurance/other-details" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <PetOtherDetails
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="Other Details"
            />
          </LayoutPlain>
        </Route>

        <Route path="/pet-insurance/client-details" exact>
          <LayoutPlain GATitle={""} sendGTM={sendGTM}>
            <PetClientDetails
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="Client Details"
            />
          </LayoutPlain>
        </Route>

        <Route path="/pet-insurance/summary" exact>
        <Layout main="summary" headerTitle="Summary">
            <PetSummary
              headerTitle="GCash x Standard Insurance"
              subheaderTitle=""
            />
          </Layout>
        </Route> */}

        <Route path="/pet-insurance/review" exact>
          <LayoutPlain GATitle={"PetFormsReview"} sendGTM={sendGTM}>
            <PetReview
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="Review"
            />
          </LayoutPlain>
        </Route>

        <Route path="/pet-faq" exact>
          <LayoutPlain GATitle={"PetFAQPage"} sendGTM={sendGTM} main="faq">
            <PetFaq
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="FAQs"
            />
          </LayoutPlain>
        </Route>


        {/** ========== Motorcyle ========== */}

        {/* <Route path="/info/exclusions" exact>
          <LayoutPlain GATitle={"CoverExclusions"}>
            <ExclusionPage
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="Exclusions"
            />
          </LayoutPlain>
        </Route>

        <Route path="/info/inclusions" exact>
          <LayoutPlain GATitle={"CoverInclusions"}>
            <Inclusions
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="Inclusions"
            />
          </LayoutPlain>
        </Route> */}

        {/* <Route path="/info/faq" exact>
          <LayoutPlain GATitle={"FAQsPages"} sendGTM={sendGTM}>
            <InfoFaqPage
              headerTitle="GCash x Standard Insurance"
              subheaderTitle="FAQs"
            />
          </LayoutPlain>
        </Route> */}


      </Switch>
    </div>
  );
}

export default App;
